<template>
  <div class="page-template" v-loading="loading">
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="历史往来账款" name="allAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="allAccount" :tableOptions="allAccount"></table-template>
      </el-tab-pane>
      <el-tab-pane label="应付账款明细" name="UnpaidAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="UnpaidAccount" :tableOptions="UnpaidAccount"></table-template>
      </el-tab-pane>
      <el-tab-pane label="已付账款明细" name="payAccount">
        <search-form-template
          ref="searchOptions"
          :searchOptions="searchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="toolConfig"
          @btnCommon="exportExcel"
        ></search-form-template>
        <table-template ref="payAccount" :tableOptions="payAccount"></table-template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import searchFormTemplate from '@/components/template/searchFormTemplate';
  import tableTemplate from '@/components/template/tableTemplate';
  import api from '@/config/api';

  import userPower from '@/mixin/userPower'

  export default {
  mixins: [userPower],
  name: 'RoleManager',
  components: {
    tableTemplate,
    searchFormTemplate,
  },
  data() {
    return {
      activeTab: 'allAccount',
      loading: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {roleId: ''}
        }
      },
      // 高级搜索条件
      searchOptions: {
        simple: [{label: '', prop: 'wholesaleOrderNo', type: 'input', placeholder: '单号'}],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            span: 24
          },
          {
            label: "门店名称",
            type: "select",
            prop: "storeId",
            span: 6,
            data: [],
            isHasAll: true,
            // change: this.storeChange,
            url: api.system.seStore
          },
          {
            label: '客户',
            type: 'select',
            prop: 'customerId',
            data: [],
            span: 6,
            url: api.wholesale.archives
          },
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '打印',
          code: 'print'
        },
        {
          label: '导出',
          code: 'export',
          callback: this.exportExcel
        }
      ],
      // 历史账款
      allAccount: {
        indexShow: true,//是否显示索引
        param: {},
        showSummary: true,
        summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount'],
        columns: [
          {
            label: '门店',
            prop: 'storeName',
            width: '150',
            align: 'center'
          },
          {
            label: '客户',
            prop: 'customerName',
            width: '150',
            align: 'center'
          },
          {
            label: '单号',
            prop: 'wholesaleOrderNo',
            width: '220',
            align: 'center',
            callback: this.goOrderDetail
          }, {
            label: '单据类型',
            prop: 'wholesaleType',
            width: '90',
            align: 'center',
            enumData: this.$utils.getCacheStatus("stCustomerSettlementMap.wholesaleType")
          },
          {
            label: '单据日期',
            prop: 'wholesaleDttm',
            width: '180',
            align: 'center'
          },
          {
            label: '对账单号',
            prop: 'billOrderNo',
            width: '220',
            align: 'center',
            callback: this.goBillOrderDetail
          },
          {
            label: '应收金额',
            prop: 'payAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '实收金额',
            prop: 'amountPaid',
            width: '90',
            align: 'center'
          },
          {
            label: '优惠金额',
            prop: 'discountedAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '未收金额',
            prop: 'outstandAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '最后结算日期',
            prop: 'settlementDttm',
            width: '180',
            align: 'center'
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '150',
            align: 'center'
          }
        ],
        url: api.settle.customerSettlementQuery
      },
      // 应付账款明细
      UnpaidAccount: {
        indexShow: true,//是否显示索引
        param: {settlementStatusList: [10, 20]},
        showSummary: true,
        summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount'],
        columns: [
          {
            label: '门店',
            prop: 'storeName',
            width: '150',
            align: 'center'
          },
          {
            label: '供应商',
            prop: 'customerName',
            width: '150',
            align: 'center'
          },
          {
            label: '单号',
            prop: 'wholesaleOrderNo',
            width: '220',
            align: 'center',
            callback: this.goOrderDetail
          }, {
            label: '单据类型',
            prop: 'wholesaleType',
            width: '90',
            align: 'center',
            enumData: this.$utils.getCacheStatus("stCustomerSettlementMap.wholesaleType")
          },
          {
            label: '单据日期',
            prop: 'wholesaleDttm',
            width: '180',
            align: 'center'
          },
          {
            label: '对账单号',
            prop: 'billOrderNo',
            width: '220',
            align: 'center',
            callback: this.goBillOrderDetail
          },
          {
            label: '应收金额',
            prop: 'payAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '实收金额',
            prop: 'amountPaid',
            width: '90',
            align: 'center'
          },
          {
            label: '优惠金额',
            prop: 'discountedAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '未收金额',
            prop: 'outstandAmount',
            width: '90',
            align: 'center'
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '150',
            align: 'center'
          }
        ],
        url: api.settle.customerSettlementQuery
      },
      // 已付账款明细
      payAccount: {
        indexShow: true,//是否显示索引
        param: {},
        showSummary: true,
        summaryColumns: ['actualPayAmount', 'discountMoney'],
        columns: [
          {
            label: '门店',
            prop: 'storeName',
            width: '150',
            align: 'center'
          },
          {
            label: '供应商',
            prop: 'customerName',
            width: '150',
            align: 'center'
          },
          {
            label: '单号',
            prop: 'wholesaleOrderNo',
            width: '220',
            align: 'center',
            callback: this.goOrderDetail
          }, {
            label: '单据类型',
            prop: 'wholesaleType',
            width: '90',
            align: 'center',
            enumData: this.$utils.getCacheStatus("stCustomerSettlementMap.wholesaleType")
          },
          {
            label: '应收金额',
            prop: 'payAmount',
            width: '110',
            align: 'center'
          },
          {
            label: '累计实收金额',
            prop: 'amountPaid',
            width: '110',
            align: 'center'
          },
          {
            label: '累计优惠金额',
            prop: 'discountedAmount',
            width: '110',
            align: 'center'
          },
          {
            label: '本次实收金额',
            prop: 'actualPayAmount',
            width: '110',
            align: 'center'
          },
          {
            label: '本次优惠金额',
            prop: 'discountMoney',
            width: '110',
            align: 'center'
          },
          {
            label: '未收金额',
            prop: 'outstandAmount',
            width: '110',
            align: 'center'
          },
          {
            label: '结算单号',
            prop: 'orderNo',
            width: '180',
            align: 'center',
            callback: this.goSettlementOrderDetail
          },
          {
            label: '结算日期',
            prop: 'reviewerDttm',
            width: '180',
            align: 'center'
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '150',
            align: 'center'
          }
        ],
        url: api.settle.customerSettlementComplete
      },

      salesDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          },
          {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: '仓库',
            prop: 'warehouseName',
          }, {
            label: '经手人',
            prop: 'salesman',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            tableName: "wlWholesaleOrderGoodsMapList",
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '序号',
                prop: 'indexShow',
                width: '50',
                align: "center"
              },
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleSales
      },
      returnDetailColumns:  {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '100px',
          top: '0',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          },
          {
            label: "批发门店",
            prop: "storeName",
          }, {
            label: '批发客户',
            prop: 'wholesaleCustomerName',
          }, {
            label: "仓库",
            prop: "warehouseName",
          }, {
            label: '经手人',
            prop: 'salesman',
          },
          {
            label: '批发销售单',
            type: 'select',
            prop: 'wholesaleOrderNo',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          wlWholesaleOrderGoodsMapList: {
            url: api.wholesale.wholesaleQuery + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            tableName: "wlWholesaleOrderGoodsMapList",
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          wlWholesaleOrderGoodsMapList: {
            tableName: 'wlWholesaleOrderGoodsMapList',
            showSummary: true,
            summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
            columns: [
              {
                label: '条码',
                prop: 'barCode',
                width: '180',
                align: "center"
              },
              {
                label: "商品名称",
                prop: "goodsName",
                width: '120',
                align: "center"
              },
              {
                label: "规格",
                prop: "specs",
                width: '90',
                align: "center"
              },
              {
                label: '单位',
                width: '90',
                prop: 'unitName',
                align: "center"
              },
              {
                label: '自编码',
                width: '125',
                prop: 'artNo',
                align: "center"
              },
              {
                label: '数量',
                width: '90',
                prop: 'goodsCount',
                type: 'inputNumber',
                align: "center"
              },
              {
                label: '赠送数量',
                width: '90',
                prop: 'giveGoodsCount',
                align: "center"
              },
              {
                label: '原价',
                width: '90',
                prop: 'beforePrince',
                align: "center"
              },
              {
                label: '原价金额',
                width: '90',
                prop: 'beforeAmt',
                align: "center"
              },
              {
                label: '折扣',
                width: '90',
                prop: 'discountRate',
                align: "center"
              },
              {
                label: '折扣价格',
                width: '90',
                prop: 'discountPrince',
                align: "center"
              },
              {
                label: '小计金额',
                width: '90',
                prop: 'discountAmt',
                align: "center"
              },
              {
                label: '系统库存',
                width: '90',
                prop: 'inventoryNum',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.wholesale.wholesaleReturn
      },
      billDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '200px',
          top: '30px',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          }, {
            label: '客户',
            prop: 'customerName',
          }, {
            label: '门店',
            prop: 'storeName',
          }, {
            label: '单据金额',
            prop: 'billAmount',
          }, {
            label: '备注',
            prop: 'remarks',
          }],
        tablesProp: {
          stCustomerBillMapMVOList: {
            url: api.settle.customerBillMap + "/page",
            showSummary: true,
            indexShow: true,
            height: this.detailHeight,
            tableName: "stCustomerBillMapMVOList",
            summaryColumns: ['payAmount'],
            columns: [
              {
                label: '单据号',
                prop: 'wholesaleOrderNo',
                width: '180',
                align: "center"
              },
              {
                label: "门店编码",
                prop: "storeCode",
                width: '120',
                align: "center"
              },
              {
                label: "门店名称",
                prop: "storeName",
                width: '90',
                align: "center"
              },
              {
                label: '单据类型名称',
                width: '90',
                prop: 'type',
                align: "center",
                enumData: this.$utils.getCacheStatus('stCustomerBillMap.type'),
              },
              {
                label: '单据日期',
                width: '125',
                prop: 'wholesaleDttm',
                align: "center"
              },
              {
                label: '应收金额',
                width: '90',
                prop: 'payAmount',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          }
        },

        // 打印的列表
        printTablesProp: {
          stCustomerBillMapMVOList: {
            tableName: 'stCustomerBillMapMVOList',
            showSummary: true,
            summaryColumns: ['payAmount'],
            columns: [
              {
                label: '单据号',
                prop: 'wholesaleOrderNo',
                width: '180',
                align: "center"
              },
              {
                label: "门店编码",
                prop: "storeCode",
                width: '120',
                align: "center"
              },
              {
                label: "门店名称",
                prop: "storeName",
                width: '90',
                align: "center"
              },
              {
                label: '单据类型名称',
                width: '90',
                prop: 'type',
                align: "center",
                enumData: this.$utils.getCacheStatus('stCustomerBillMap.type'),
              },
              {
                label: '单据日期',
                width: '125',
                prop: 'wholesaleDttm',
                align: "center"
              },
              {
                label: '应收金额',
                width: '90',
                prop: 'payAmount',
                align: "center"
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.settle.billCustomer
      },
      settlementDetailColumns: {
        statusOption: {
          prop: 'reviewerStatus',
          statusImg: {
            10: '/static/checked.png',
            20: '/static/un-check.png'
          },
          right: '200px',
          top: '30px',
        },
        span: 8,
        labelWidth: "130",
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
          }, {
            label: '客户',
            prop: 'customerName',
          }, {
            label: '门店',
            prop: 'storeName',
          },
          {
            label: '付款方式',
            prop: 'payType',
            enumData: this.$utils.getCacheStatus("stCustomerSettlementOrder.payType"),
          },
          {
            label: '付款金额',
            prop: 'billAmount',
          },
          {
            label: '备注',
            prop: 'remarks',
          }
        ],
        tablesProp: {
          stCustomerSettlementMapList: {
            url: api.settle.customerSettlementMap + "/page",
            showSummary: true,
            indexShow: true,
            height:this.detailHeight,
            tableName: "stCustomerSettlementMapList",
            summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
            columns: [
              {
                label: '单据号',
                prop: 'wholesaleOrderNo',
                width: '220',
                align: "center",
              },
              {
                label: "单据类型",
                prop: "wholesaleType",
                width: '120',
                align: "center",
                enumData: this.$utils.getCacheStatus('stCustomerSettlementMap.wholesaleType')
              },
              {
                label: "单据日期",
                prop: "billDttm",
                width: '180',
                align: "center"
              },
              {
                label: '对账单号',
                prop: 'billOrderNo',
                width: '220',
                align: "center",
              },
              {
                label: '应收金额',
                width: '90',
                prop: 'payAmount',
                align: "center",
              },
              {
                label: '已收金额',
                width: '125',
                prop: 'amountPaid',
                align: "center"
              },
              {
                label: '已优惠金额',
                width: '120',
                prop: 'discountedAmount',
                align: "center"
              },
              {
                label: '未收金额',
                width: '90',
                prop: 'outstandAmount',
                align: "center"
              },
              {
                label: '实收金额',
                width: '90',
                prop: 'actualPayAmount',
                align: "center",
                precision: 2
              },
              {
                label: '优惠金额',
                width: '90',
                prop: 'discountMoney',
                align: "center",
                precision: 2
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },

        // 打印的列表
        printTablesProp: {
          stCustomerSettlementMapList: {
            tableName: 'stCustomerSettlementMapList',
            showSummary: true,
            summaryColumns: ['payAmount'],
            columns: [
              {
                label: '序号',
                prop: 'indexShow',
                width: '50',
                align: "center"
              },
              {
                label: '单据号',
                prop: 'wholesaleOrderNo',
                width: '220',
                align: "center",
              },
              {
                label: "单据类型",
                prop: "wholesaleType",
                width: '120',
                align: "center",
                enumData: this.$utils.getCacheStatus('stCustomerSettlementMap.wholesaleType')
              },
              {
                label: "单据日期",
                prop: "billDttm",
                width: '180',
                align: "center"
              },
              {
                label: '对账单号',
                prop: 'billOrderNo',
                width: '220',
                align: "center",
              },
              {
                label: '应收金额',
                width: '90',
                prop: 'payAmount',
                align: "center",
              },
              {
                label: '已收金额',
                width: '125',
                prop: 'amountPaid',
                align: "center"
              },
              {
                label: '已优惠金额',
                width: '120',
                prop: 'discountedAmount',
                align: "center"
              },
              {
                label: '未收金额',
                width: '90',
                prop: 'outstandAmount',
                align: "center"
              },
              {
                label: '实收金额',
                width: '90',
                prop: 'actualPayAmount',
                align: "center",
                precision: 2
              },
              {
                label: '优惠金额',
                width: '90',
                prop: 'discountMoney',
                align: "center",
                precision: 2
              },
              {
                label: '备注',
                prop: 'remarks',
                width: '90',
                align: "center"
              },
            ],
          },
        },
        url: api.settle.settlementCustomer
      }
    };
  },
  created() {
    this.title = document.title;
    this.setStore(this.searchOptions.complex)
  },
  mounted() {
  },
  methods: {
    goSettlementOrderDetail(row) {
      this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.settlementDetailColumns);
      const {href} = this.$router.resolve({
        name: "SettlementCustomerDetail",
        query: {id: row.settlementId},
      });
      window.open(href, "_blank");
    },
    goBillOrderDetail(row) {
      this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.billDetailColumns);
      const {href} = this.$router.resolve({
        name: "BillCustomerDetail",
        query: {id: row.billId},
      });
      window.open(href, '_blank');
    },
    goOrderDetail(row) {
      console.log(row);
      if (row.wholesaleType === 50) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.salesDetailColumns);
        const {href} = this.$router.resolve({
          name: 'SalesDetail',
          query: {id: row.wholesaleId}
        });
        window.open(href, '_blank');
      } else {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.returnDetailColumns);
        const {href} = this.$router.resolve({
          name: 'wholeasleReturnDetail',
          query: {id: row.wholesaleId}
        });
        window.open(href, '_blank');
      }
    },

    // 选择门店
    storeChange(form) {
      form.customerId = '';
      this.$axios.fetchPost(api.wholesale.archives + '/list', {storeId: form.storeId}).then(data => {
        if (data.code === 200) {
          this.searchOptions.complex.filter((item) => item.prop === "customerId")[0].data = data.data;
        } else {
          this.$message({message: '门店获取客户失败', type: 'error'});
        }
      });
    },
    // 点击重置 刷新列表
    clearSearch() {
      this.$refs['allAccount'].clearSearch();
      this.$refs['UnpaidAccount'].clearSearch();
      this.$refs['payAccount'].clearSearch();
    },
    // 点击搜索
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },
    tabChange() {
      this.$refs.searchOptions1.complexClear()
      this.$refs.searchOptions2.complexClear()
      this.$refs[this.activeTab].searchParam = {}
      this.$refs[this.activeTab].operationSuccess();
    },
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let fileName, param;
      let url = '';
      switch (this.activeTab) {
        case 'allAccount':
          param = this.$refs["allAccount"].searchParam;
          fileName = '历史往来账款_' + this.$utils.getDateTime() + '.xls';
          url = api.settle.customerSettlementExport;
          break;
        case 'UnpaidAccount':
          param = this.$refs["UnpaidAccount"].searchParam;
          param.settlementStatusList = [10, 20];
          fileName = '应付账款明细_' + this.$utils.getDateTime() + '.xls';
          url = api.settle.customerUnpaidAccountExport;
          break;
        case 'payAccount':
          param = this.$refs["payAccount"].searchParam;
          fileName = '已付账款明细_' + this.$utils.getDateTime() + '.xls';
          url = api.settle.customerPayAccountExport;
          break;
      }
      this.$axios.PostBlob(url, param).then(res => {
        if (res.status === 200) {
          let blob = new Blob([res.data])
          let downloadElement = document.createElement('a');
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功!文件名称:' + fileName,
            showClose: false,
          });
          // this.$message.success("导出成功,文件名称:" + fileName);
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message.warning("当前导出数据为空或超出10000条。");
        }
      }).catch(() => {
        this.$message.warning("当前导出数据为空或超出10000条。");
      }).finally(() => {
        loading.close();
      })
    },
  }
}
</script>

<style scoped>
.page-template {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/page/settle/query/CustomerSettlement.vue